import { selectFeatureFlags } from 'core/userContext';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Checkbox, CHECKBOX_STATUS } from 'ui/checkbox';
import { FormField } from 'ui/formField';
import { TopTooltip } from 'ui/tooltip';
import { Link } from 'ui/links';
import { CheckboxLabel, CheckboxWrapper } from 'modules/templateEditor/common/CheckboxField';
import { FlexSpacer } from 'ui/flexSpacer';
import { displayContent, getIsEditMode, SettingsReadOnlyText, TwoRowFieldDisplay } from '.';
import { useEditableFieldsContext } from '../context/EditableFieldsContext';
import { useQueryParamContext } from '../context/QueryParamContext';
import { LINK_SHORTENING_DISPLAY_CONTENT } from './constants';

const LinkShortenCheckboxWrapper = styled(CheckboxWrapper)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const CenteredCheckbox = styled(Checkbox)`
  display: flex;
`;

export const FormFieldStartTooltipContent = styled.div`
  text-align: start;
`;

export const LinkShorteningFormSection = () => {
  const { LinkShortening, LinkShorteningTemplateLevelAccess } = useSelector(selectFeatureFlags);
  const { view } = useQueryParamContext();
  const { isEditMode, liveTemplate, setCurrentTemplateField } = useEditableFieldsContext();
  const isEditModeVisible = getIsEditMode(view, isEditMode);
  const checkboxStatus =
    !LinkShorteningTemplateLevelAccess || !!liveTemplate.shortenLinks
      ? CHECKBOX_STATUS.CHECKED
      : CHECKBOX_STATUS.UNCHECKED;
  const isOn = checkboxStatus === CHECKBOX_STATUS.CHECKED;

  return (
    <>
      {LinkShortening && (
        <FormField
          data-test="link-shortening-form-section"
          isHorizontalLayout
          labelText={LINK_SHORTENING_DISPLAY_CONTENT.labelText}
        >
          {isEditModeVisible ? (
            <LinkShortenCheckboxWrapper>
              <FlexSpacer gap="0px">
                <TopTooltip
                  isEnabled={!LinkShorteningTemplateLevelAccess}
                  tooltipContent={
                    <FormFieldStartTooltipContent>
                      {displayContent.linksShorteningDisabledTooltip}
                    </FormFieldStartTooltipContent>
                  }
                >
                  <CenteredCheckbox
                    isDisabled={!LinkShorteningTemplateLevelAccess}
                    label={LINK_SHORTENING_DISPLAY_CONTENT.checkboxLabel}
                    onClick={() => {
                      setCurrentTemplateField('shortenLinks', !liveTemplate.shortenLinks);
                    }}
                    status={checkboxStatus}
                  />
                </TopTooltip>
                <CheckboxLabel>{LINK_SHORTENING_DISPLAY_CONTENT.checkboxLabel}</CheckboxLabel>
              </FlexSpacer>
              <Link
                size="caption"
                href="https://support.iterable.com/hc/articles/36464011594900-Troubleshooting-Message-Clipping"
              >
                Learn more
              </Link>
            </LinkShortenCheckboxWrapper>
          ) : (
            <TwoRowFieldDisplay>
              <SettingsReadOnlyText isUnset={!isOn} data-test="link-param-on-off">
                {isOn ? 'On' : 'Off'}
              </SettingsReadOnlyText>
            </TwoRowFieldDisplay>
          )}
        </FormField>
      )}
    </>
  );
};
